import {LocaleType} from '../enum/LocaleType'

const languageTagAliases: Record<string, LocaleType> = {
  uk: LocaleType.Ukrainian,
  nb: LocaleType.Norwegian,
  nn: LocaleType.Norwegian,
}

function isLocaleType(value: string): value is LocaleType {
  return Object.values(LocaleType).includes(value as LocaleType)
}

/** The app language of a BCP 47 tag (navigator.language, Accept-Language), or null when the app does not speak it. */
export function findLocaleTypeFromLanguageTag(languageTag: string | undefined | null): LocaleType | null {
  const normalized = languageTag?.trim().toLowerCase().replace('_', '-')
  if(!normalized) {
    return null
  }
  if(isLocaleType(normalized)) {
    return normalized
  }
  const primary = normalized.split('-')[0]
  if(languageTagAliases[primary]) {
    return languageTagAliases[primary]
  }
  return isLocaleType(primary) ? primary : null
}
